import axios from 'axios'
import { BUSCAR_ENDERECO_POR_CEP } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarEnderecoPorCep (CEP) {
  const url = `${URL}/cep/public/${CEP}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_ENDERECO_POR_CEP,
        payload: response

      })
  );
}
